import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/enrollments/purchase/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const purchase = {
  post: apiPathFunc(pathBase),
} as const;
